import { render, staticRenderFns } from "./BaseFormRadio.vue?vue&type=template&id=08898799&scoped=true"
import script from "./BaseFormRadio.vue?vue&type=script&lang=js"
export * from "./BaseFormRadio.vue?vue&type=script&lang=js"
import style0 from "./BaseFormRadio.vue?vue&type=style&index=0&id=08898799&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08898799",
  null
  
)

export default component.exports